<template>
    <div>
        <div class="md-layout" id="regions-section">
            <regions-menu :cropSelected="cropSelected"
                          :cropsRegions="cropsRegions"
                          :menuOptions="menuOptions"
                          :optionSelected="optionSelected"
                          :info="info"
                          @update-selected-crop="updateSelectedCrop"
                          @update-selected-option="updateSelectedOption"
            />
            <div class="md-layout layout-margin">
                <div class="md-layout-item md-size-30 md-small-size-100">
                    <br>
                    <region-map v-if="mapReady" class="map-chart" :data="mapData" />
                </div>
                <div class="md-layout-item md-size-70 md-small-size-100 regions-item-container">
                    <region-cards :optionSelected="optionSelected" />
                </div>
                <div class="md-layout-item md-size-100">
                    <bars v-if="rindReady"
                          :data="rindData"
                          :regions="regions"/>
                </div>
                <div class="md-layout-item md-size-100">
                    <bar-line-scatter v-if="priceReady"
                                      :data="priceData"
                                      :regions="regions" />
                </div>
            </div>
        </div>
        <modal @close="closeModal" v-if="displayModal" class="advertising-modal">
            <template slot="body">
                <img :src="adv[4]" style="max-height: 500px">
            </template>
            <template slot="footer">
                <md-button class="md-danger md-simple" @click="closeModal">Cerrar</md-button>
            </template>
        </modal>
    </div>
</template>

<script>
import { mapState } from 'vuex'

import Bars from '@/components/Graphs/Bars'
import RegionMap from '@/components/Regions/RegionMap'
import RegionCards from '@/components/Regions/RegionCards'
import BarLineScatter from '@/components/Graphs/BarLineScatter'
import Tabs from '@/components/Tabs'
import Modal from '@/components/Modal'
import RegionsMenu from '@/components/Regions/Menu'


export default {
  components: { Tabs, BarLineScatter, Bars, RegionMap, Modal, RegionsMenu, RegionCards },

  data ()  {
    return {
      cropSelected: '',
      displayModal: false,
      optionSelected: 'Margen Bruto',
      menuOptions: ['Margen Bruto', 'Margen Neto', 'Rentabilidad', 'Rinde de Equilibrio', 'Precio de Equilibrio' ],
      mapData: [],
      mapReady: false,
      rindData: {
        indif: [],
        pres: [],
        max:0,
        min:0
      },
      priceData: {
        indif: [],
        ref: [],
        dolor:[],
      },
      priceReady:false,
      rindReady: false
    }
  },
  computed: {
    ...mapState(['regions','cropsRegions','data','headers','coords','info','adv'])
  },
  watch: {
    optionSelected: function() {
      this.loadData();
    },
    cropSelected: function() {
      this.loadData();
    }
  },
  methods: {
    closeModal() {
      this.displayModal= false;
    },
    updateSelectedOption(option) {
      this.optionSelected = option;
    },
    updateSelectedCrop(crop) {
      this.cropSelected = crop;
    },
    getMarginValue(row) {
      switch(this.optionSelected){
      case 'Margen Bruto': return row['margen_bruto'];
      case 'Margen Neto': return row['margen_neto'];
      case 'Rentabilidad': return row['renta'];
      case 'Rinde de Equilibrio': return row['rinde_equilibrio'];
      case 'Precio de Equilibrio': return row['precio_equilibrio'];
      default: return 'n/a';
      }
    },
    getDataRow(payload) {
      let response = [];
      for (let key in this.data)
        if (this.data[key][0] == payload.regionSelected  && this.data[key][1] == payload.cropSelected ) {
          let row = this.data[key];
          for (let index in row){
            response[this.headers[index]] = row[index];
          }
        }
      return response;
    },
    mapDataLoad() {
      for (let key in this.regions){
        let data = {};

        let row = this.getDataRow({cropSelected: this.cropSelected, regionSelected:this.regions[key]});
        data.name = [];
        data.name[0] = this.regions[key];
        data.name[1] = 'Margen Bruto: '+row['margen_bruto']+' <em>USD/ha</em>';
        data.name[2] = 'Margen Neto: '+row['margen_neto']+' <em>USD/ha</em>';
        data.name[3] = 'Rentabilidad: '+row['renta']+' <em>%</em>';
        data.name[4] = 'Rinde de Equilibrio: '+row['rinde_equilibrio']+' <em>qq/ha</em>';
        data.name[5] = 'Precio de Equilibrio: '+row['precio_dolor']+ ' <em>USD/t</em>';
        data.value = this.getMarginValue(row);
        data.coord = [parseFloat(this.coords[this.regions[key]][0]), parseFloat(this.coords[this.regions[key]][1])];

        this.mapData.push(data);
      }
      this.mapReady = true;
    },
    rindDataLoad() {
      for (let key in this.regions){
        let row = this.getDataRow({cropSelected: this.cropSelected, regionSelected: this.regions[key]});
        this.$set(this.rindData.pres,key,row['rinde_presupuestado']);
        this.$set(this.rindData.indif,key,row['rinde_equilibrio']);
      }
    },

    priceDataLoad() {
      for (let key in this.regions){
        let row = this.getDataRow({cropSelected: this.cropSelected, regionSelected: this.regions[key]});
        this.$set(this.priceData.ref,key,row['precio_referencia']);
        this.$set(this.priceData.indif,key,row['precio_equilibrio']);
        this.$set(this.priceData.dolor,key,row['precio_dolor']);
      }
    },

    loadData() {
      this.mapDataLoad();
      this.rindDataLoad();
      this.priceDataLoad();
    }
  },

  mounted() {
    this.cropSelected = this.cropsRegions[0];
    this.$nextTick(function() {
      this.priceReady = true;
      this.rindReady = true;
    });
    //setTimeout(() => { this.displayModal = true; }, 3000);
  }
}
</script>
<style>

.regions-card{
    margin: 15px 0 !important;
    padding-bottom: 10px;
}

.regions-item-container{
  overflow-x: scroll;
}

.regions-item{
    padding-top: 15px;
}
.title-bread .title{
    margin-top:7px;
    margin-left:5px;
    display: inline-block;
    height:30px;
}
em{
    font-size:10px;
    font-style: normal
}

.regions-card .card-icon{
    padding: 5px !important;
    font-size: 11px !important;
    margin-right:0 !important;
}
.regions-card  .unit{
    font-size:10px
}
.regions-card .md-card-header .card-icon + .category{
    padding-top: 20px !important;
}
.regions-card .category{
    font-size:12px !important;
    margin: 0 -8px !important;
}

@media only screen and (max-width: 1185px) {
  .regions-card .category{
    font-size: 10px !important;
  }
  .card-icon .number-sub{
    font-size: 10px ;
  }
}
@media only screen and (max-width: 992px) {
  .main-panel > .content{
    margin-top: 64px
  }
  .echarts.map-chart {
    width: 40%;
    margin: 0 auto;
  }

}
@media only screen and (max-width: 768px) {

}
@media only screen and (max-width: 600px) {
  .echarts.map-chart {
    width: 100%;
    margin: 0 auto;
  }
  .regions-item{
    width: 2100px;
    flex-wrap: nowrap;
    margin-top: 20px;
  }
  .regions-item .md-layout-item.md-size-25{
    min-width: 180px;
    max-width: 180px;
  }
}
</style>

